import React, { useEffect } from 'react';
import { Typography, Row, Col, Divider } from 'antd';
import '../../Styles/ResearchLabs.css';

import AppHeader from '../../Layout/Header';
import FooterComponent from '../../Layout/Footer';

import istlogo from '../../Assets/Brand/ist-logo.png';
import istCampus from '../../Assets/ResearchLabs/Common/IST-Campus.jpg';
import sstrlBanner from '../../Assets/ResearchLabs/SSTRL/sstrlbanner.jpg';

import SstrlScope from './SSTRL Components/SstrlScope';
import SstrlDomain from './SSTRL Components/SstrlDomain';
import SstrlHead from './SSTRL Components/SstrlHead';
import Impact from './SSTRL Components/Impact';
import SocialFeed from './SSTRL Components/SocialFeed';

const { Title } = Typography;


const SmallSatelliteTechnologyandResearchLab = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);
    return (
        <>
            <AppHeader />
            <main className="individual-lab-page">


            {/* =====================================================
                SSTRL BANNER
                ===================================================== */}

            <div
                className="sarl-lab-hero"
                role="img"
                aria-label="Small Satellite Technology and Research Lab"
                style={{ backgroundImage: `url(${sstrlBanner})` }}
            />


            {/* =====================================================
                HOST UNIVERSITY
                ===================================================== */}

            <section className="sarl-host-section">

                <div className="sarl-host-inner">

                    <Row
                        gutter={[72, 40]}
                        align="middle"
                        justify="space-between"
                    >

                        {/* University Information */}

                        <Col xs={24} md={11}>

                            <Title
                                level={2}
                                className="sarl-host-title"
                            >
                                Host University
                            </Title>

                            <Divider className="ncgsa-divider" />

                            <div className="sarl-host-identity">

                                <img
                                    src={istlogo}
                                    alt="Institute of Space Technology logo"
                                    className="sarl-host-logo"
                                />

                                <Title
                                    level={5}
                                    className="sarl-host-name"
                                >
                                    Institute of Space Technology, Islamabad
                                </Title>

                            </div>

                        </Col>


                        {/* IST Campus */}

                        <Col xs={24} md={10}>

                            <img
                                src={istCampus}
                                alt="Institute of Space Technology campus"
                                className="sarl-host-campus"
                            />

                        </Col>

                    </Row>

                </div>

            </section>


            {/* =====================================================
                SSTRL CONTENT
                ===================================================== */}

            <SstrlScope />

            <SstrlDomain />

            <Impact />

            <SstrlHead />
            <SocialFeed />


            {/* =====================================================
                FOOTER
                ===================================================== */}

            </main>
            <FooterComponent />

        </>
    );
};


export default SmallSatelliteTechnologyandResearchLab;
